import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { lazy } from "react";
import PathList from "./PathList";
import LoginScreen from "../Pages/Login/Login.jsx";
import Loader from "./Loader.jsx";
import Layout from "../Pages/Layout/MainLayout.jsx";
import PrivateRoute from "../Component/PrivateRoute.jsx";
import PartnerManagement from "../Pages/PartnerManagement/PartnerManagement.jsx";
import BookingManagement from "../Pages/Booking/BookingManagement.jsx";
import ContactUsScreen from "../Pages/ContactUs/ContactUsScreen.jsx";
import UserDetailsScreen from "../Pages/UserDetails/UserDetailsScreen.jsx";
import ContentManagement from "../Pages/ContentManagement/ContentManagement.jsx";
import ReviewScreen from "../Pages/Review/ReviewManagement.jsx";
import FAQsManagement from "../Pages/FAQs/FAQsManagement.jsx";
import PartnerDetailsScreen from "../Pages/PartnerDetails/PartnerDetailsScreen.jsx";
import InquiryScreen from "../Pages/Inquiry/InquiryScreen.jsx";
import NewsLetterManagement from "../Pages/NewsLetter/NewsLetter.jsx";
import DiscountCouponManagement from "../Pages/DiscountCoupon/DiscountCouponManagement.jsx";

const DashLazyComponent = lazy(() =>
  import("../Pages/Dashboard/DashboardScreen.jsx")
);

const UserLazyComponent = lazy(() =>
  import("../Pages/User/UserManagementScreen.jsx")
);

const RouteData = [
  {
    path: PathList._Dashboard,
    element: <DashLazyComponent />,
  },
  {
    path: PathList._User,
    element: <UserLazyComponent />,
  },
  {
    path: PathList._Partners,
    element: <PartnerManagement />,
  },
  {
    path: PathList._Booking,
    element: <BookingManagement />,
  },
  {
    path: PathList._Review,
    element: <ReviewScreen />,
  },
  {
    path: PathList._Content,
    element: <ContentManagement />,
  },
  {
    path: PathList._Contact,
    element: <ContactUsScreen />,
  },
  {
    path: PathList._Inquiry,
    element: <InquiryScreen />,
  },

  {
    path: PathList._FAQs,
    element: <FAQsManagement />,
  },
  {
    path: PathList._NewsLetter,
    element: <NewsLetterManagement />,
  },
  {
    path: PathList._Disc_Coupon,
    element: <DiscountCouponManagement />,
  },
];
const RouteDataWithoutSidebar = [
  {
    path: PathList._UserDetails,
    element: <UserDetailsScreen />,
  },
  {
    path: `${PathList._PartnerDetails}/:id`,
    element: <PartnerDetailsScreen />,
  },
];

export default function RouteList() {
  return (
    <div>
      <Routes>
        <Route path={PathList._Login} element={<LoginScreen />} />
        {RouteData.map(({ element, path }, i) => (
          <Route
            key={i}
            path={path}
            element={
              <PrivateRoute
                children={
                  <Layout
                    element={
                      <Suspense fallback={() => <Loader />}>{element}</Suspense>
                    }
                  />
                }
              />
            }
          />
        ))}
        {RouteDataWithoutSidebar.map(({ element, path }, i) => (
          <Route
            key={i}
            path={path}
            element={
              <PrivateRoute
                children={
                  <Suspense fallback={() => <Loader />}>{element} </Suspense>
                }
              />
            }
          />
        ))}
      </Routes>
    </div>
  );
}
